import React, { useContext, useEffect, useState } from "react";
// import { FAQ } from "../../ApiServices/FAQ/FAQApi";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { FAQ, GetWebsiteFAQList } from "../../ApiServices/FAQ/FAQApi";
import HoroscopeBannerImg from "../../assets/images/new/faqbanner.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { t } from "i18next";
import { Helmet } from "react-helmet-async";
import NoResultFoundModel from "../../Components/NoDataFound/NoDataFoundModal";
const FAQPage = () => {
  const { setLoader, selectedLanguageID, formatToIndianCurrency, isLanguageUpdate } = useContext(LoaderContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalRecords, setTotalRecords] = useState(-1);
  const [pageSize, setPageSize] = useState(30);
  const [faqs, setFaqs] = useState([]);
  const [metaDesc, setMetaDesc] = useState("Find answers to common questions about online puja booking, pandit services, homam & subscription remedy puja on Myomnamo. Get spiritual guidance with ease.");
  const [metaTitle, setMetaTitle] = useState("FAQs | Puja, Homam & Spiritual Services Help | Myomnamo ");

  useEffect(() => {
    GetFAQListData();
  }, [selectedLanguageID]);

  const GetFAQListData = async () => {

    try {
      const response = await GetWebsiteFAQList({
        pageNo: 0,
        pageSize: pageSize,
        pujaServiceID: null,
        pujaSubServiceID: null,
        moduleID: null,
        appLangID: Number(selectedLanguageID)
      });
      if (response?.statusCode === 200) {
        const list = response?.responseData?.data;
        setLoader(false);
        setFaqs(list);
        setTotalRecords(list?.length)
      }

    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };




  const FaqObj = [
    {
      question: "What services does My OmNamo offer?",
      answer:
        "Pandit Booking, Daily Pandit Booking, E-Store, Darshan Booking, Puja at Temple, Horoscope.",
      color: "#ffa415",
    },
    {
      question: "Can I schedule a temple visit through My OmNamo?",
      answer:
        "Yes, you can easily book temple visits online through our platform at your convenience.",
      color: "#fc5528",
    },
    {
      question: "Can I book personalized consultations with spiritual mentors?",
      answer:
        "Yes, you can book sessions with experienced spiritual mentors through our platform.",
      color: "#8139e7",
    },
    // {
    //   question: "Why is it important How Volunteer?",
    //   answer:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>
          {metaTitle}
        </title>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          name="description"
          content={metaDesc}
        />
        <link rel="canonical" href="https://www.myomnamo.com/faq" />
        <meta
          property="og:title"
          content={metaTitle}
        />

        <meta
          property="og:description"
          content={metaDesc}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={metaTitle}
        />
        <meta
          name="twitter:description"
          content={metaDesc}
        />

      </Helmet>
      <section className="page-header" style={{ paddingBottom: '30px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">{t("FAQ's")}
          </h2>

        </div>
      </section>
      <section className="faq-one faq-one-page-custom">
        <div
          className="container"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="section-title text-center">
            <h6
              className="sec-title__tagline bw-split-in-right"
              style={{ perspective: "400px" }}
            >
              {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
              <img className=" tagline-img" src={batuk} alt="" /> {t("FAQ's")}
              {/* <span className="sec-title__tagline__border"></span> FAQ */}
            </h6>
            <h3
              className="sec-title__title bw-split-in-left"
              style={{ perspective: "400px" }}
            >
              {t("Frequently Asked Questions")}
            </h3>
          </div>
          <div className="row">

            <div className="col-xl-12">
              <div className="faq-one__accordion careox-accordion">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`accrodion ${activeIndex === index ? "active" : ""
                      }`}
                    style={{ "--accent-color": faq.color }}
                  >
                    <div
                      className="accrodion-title"
                      onClick={() => toggleFAQ(index)}
                    >
                      <h4>
                        <span
                          className="accrodion-title__number"
                          style={{ marginRight: "10px", fontWeight: "500" }}
                        ></span>
                        {faq.question}
                        <span className="accrodion-title__icon"></span>
                      </h4>
                    </div>
                    <div
                      className="accrodion-content"
                      style={{
                        maxHeight: activeIndex === index ? "200px" : "0",
                        overflow: "hidden",
                        transition: "max-height 0.5s ease-in-out",
                      }}
                    >
                      <div className="inner">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>


      {totalRecords <= 0 && (
        <NoResultFoundModel totalRecords={totalRecords} />
      )}
    </>
  );
};

export default FAQPage;
